import React from "react";
import Tabs from "antd/lib/tabs";
import { ITabsProps } from "./interface";

const { TabPane } = Tabs;

const ZTabs: React.FC<ITabsProps> = props => {
	const { tabPanes, ...tabProps } = props;

	return (
		<Tabs {...tabProps}>
			{tabPanes.map(tabPane => {
				const { render, key, hide = false, ...rest } = tabPane;

				return !hide ? (
					<TabPane {...rest} key={key}>
						{render}
					</TabPane>
				) : null;
			})}
		</Tabs>
	);
};

export default ZTabs;
